import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { CountryListComponent } from '../country-list/country-list.component';
import { NationalityListComponent } from '../nationality-list/nationality-list.component';
import { CurrencyListComponent } from '../currency-list/currency-list.component';
import { StockExchangeListComponent } from '../stock-exchange-list/stock-exchange-list.component';

@Component({
  selector: 'app-country-setup',
  imports: [
    CommonModule,
    MatTabsModule,
    CountryListComponent,
    NationalityListComponent,
    CurrencyListComponent,
    StockExchangeListComponent
  ],
  templateUrl: './country-setup.component.html',
  styleUrl: './country-setup.component.scss'
})
export class CountrySetupComponent {
  selectedTabIndex = 0;

  onTabChange(index: number): void {
    this.selectedTabIndex = index;
  }
}
